import { render, staticRenderFns } from "./MainColorRoom.vue?vue&type=template&id=31b9f23e&scoped=true"
import script from "./MainColorRoom.vue?vue&type=script&lang=js"
export * from "./MainColorRoom.vue?vue&type=script&lang=js"
import style0 from "./MainColorRoom.vue?vue&type=style&index=0&id=31b9f23e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b9f23e",
  null
  
)

export default component.exports